export default "__VITE_ASSET__QVOlWPlt__"